import { getDailyData } from "../api/BCO/getDailyData.ts"
import { getFlowRateDisplayData } from "../api/BCO/getFlowRateDisplayData.ts"
import { getMonthlyData } from "../api/BCO/getMonthlyData.ts"

import type { SummaryRowConfig } from "../types/summaryRowTypes.ts"

export const BCOFetchers: SummaryRowConfig = {
  flowRateFetcher: getFlowRateDisplayData,
  dailyFetcher: getDailyData,
  monthlyFetcher: getMonthlyData,
  flowThresholds: [1000, 1400, 1700, 2000],
}
